import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import {
    Checkbox, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, TableSortLabel, TablePagination, TableFooter
} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import Info from '@mui/icons-material/Info';
import AddIcon from '@mui/icons-material/Add';
import CopyrightIcon from '@mui/icons-material/Copyright';
import RefreshIcon from '@mui/icons-material/Refresh';
import ApiIcon from '@mui/icons-material/Api';
import { Tooltip } from '@mui/material';
import { useLocation, Link } from 'react-router-dom';
import Modal from '@mui/material/Modal';
import { Box } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import ReactDOM from 'react-dom';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';

const PaymentAndReceiptDetails = ({ match }) => {
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const { id } = useParams();
    const { isAuthenticated, companyId, branchId, userId, logout, token } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

    }, [isAuthenticated, companyId, branchId, token, logout]);

    const [recordCount, setRecordCount] = useState(0);
    const [customerOptions, setCustomerOptions] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);

    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [invoicedeatils, setInvoicedeatils] = useState([]);
    const [formData, setFormData] = useState({
        CompanyId: companyId,
        BillDate: '',
        BillNumber: 0,
        MasterId: '',
        CreatedBy: userId,
        isSubmit: false,
        IsType: true,
    });

    const [showBankField, setShowBankField] = useState(true);
    const [isFullScreen, setIsFullScreen] = useState(false);
    useEffect(() => {
        function handleResize() {
            setIsFullScreen(window.innerWidth >= 768); // Assuming full screen width is 768px or larger, adjust as needed
        }

        window.addEventListener('resize', handleResize);
        handleResize(); // Initial check

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Add a function to format the date
    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    };

    const [selectedPaymentType, setSelectedPaymentType] = useState("1");
    const [paymentmethodOptions, setPaymentmethodOptions] = useState([]);
    const [selectedPaymentmethodType, setSelectedPaymentmethodType] = useState("");
    const parseAndFix = (val) => parseFloat(val) || 0;

    useEffect(() => {
        fetchData('PaymentAndReceiptApi', `/PaymentData/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    const invoiceData = response.response_data.PaymentAndReceipt;
                    setFormData({
                        ...invoiceData,
                        UpdatedBy: userId,
                    });
                    console.log(response);

                    const updatedInvoicedetailsSorted = response.response_data.PaymentAndReceiptInvoiceDetails;
                    setInvoicedeatils(updatedInvoicedetailsSorted);
                    console.log(updatedInvoicedetailsSorted);
                }
            })
            .catch((error) => {
                console.error('Error fetching PaymentAndReceipt Details:', error);
            });
    }, [id]);

    return (
        <div className="w-full max-w-sm container mt-6 mx-auto" style={{ minWidth: '100%', marginTop: '-50px' }}>

            <div className="flex flex-wrap justify-between items-center mb-4">
                <h6
                    className="uppercase tracking-wide text-black font-serif flex-grow"
                    style={{
                        fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif',
                        color: 'black',
                        marginTop: '10px',
                    }}
                >
                    Receipt Details
                </h6>

                <div className="flex mt-8 w-full sm:w-auto">
                    <Button
                        variant="contained"
                        color="error"
                        component={Link}
                        to={{
                            pathname: "/PaymentAndReceiptIndex",
                            state: { from: "/PaymentAndReceiptDetails" },
                        }}
                        onClick={() => {
                            localStorage.setItem("shouldReload", "true");
                        }}
                        style={{ height: "25px", borderRadius: "10px", marginRight: "5px" }}
                    >
                        Back To List
                    </Button>
                </div>
            </div>

            {errorMessage && <p className="text-red-500">{errorMessage}</p>}
            <div className="w-full flex flex-wrap" style={{ backgroundColor: 'whitesmoke', padding: '7px', borderRadius: '10px', marginTop: '-15px', boxShadow: "0 6px 10px rgba(0, 0, 0, 0.25), 0 12px 25px rgba(0, 0, 0, 0.2)" }}>

                <div className="w-full pr-4" style={{ marginTop: '-0.21%' }}>
                    <div className="w-full mb-2 flex">
                        <div className="w-3/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="supplierName">
                                Customer
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={`${formData.CustomerName || ''}`}
                                type="text"
                                placeholder="Customer Name"
                                name='CustomerName'
                                readOnly
                                style={{ height: '30px' }}
                            />
                        </div>

                        <div className="w-3/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="supplierName">
                                Consignee
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={`${formData.ConsigneeName || ''}`}
                                type="text"
                                placeholder="Consignee Name"
                                name='ConsigneeName'
                                readOnly
                                style={{ height: '30px' }}
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="billDate">
                                Bill Date
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formatDateForInput(formData.BillDate)}
                                type="date"
                                name='BillDate'
                                readOnly
                                style={{ height: '30px' }}
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="billNumber">
                                Bill No
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={`${formData.BillNumber || ''}`}
                                type="text"
                                placeholder="Bill Number"
                                name='BillNumber'
                                readOnly
                                style={{ height: '30px' }}
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="supplierName">
                                Pay Mode
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={(formData.PaymentName)}
                                type="text"
                                placeholder="Amount"
                                name='Amount'
                                style={{ textAlign: 'right', fontWeight: 'bold', height: '30px' }}
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="billNumber">
                                Amount
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={
                                    formData.Amount != null && formData.Amount !== ''
                                        ? Number(formData.Amount).toFixed(3)   // ✅ format to 3 decimals
                                        : ''
                                }
                                type="number"
                                placeholder="Amount"
                                name='Amount'
                                style={{ textAlign: 'right', fontWeight: 'bold', height: '30px' }}
                                readOnly
                            />
                        </div>

                    </div>

                    <div className="w-full mb-2 flex">

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="billNumber">
                                From Bank
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.FromBankName || ''}
                                type="text"
                                placeholder="From Bank Name"
                                name='FromBankName'
                                style={{ textAlign: 'left', fontWeight: 'bold', height: '30px' }}
                            />
                        </div>
                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="billNumber">
                                To Bank
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.ToBankName || ''}
                                type="text"
                                placeholder="To Bank Name"
                                name='ToBankName'
                                style={{ textAlign: 'left', fontWeight: 'bold', height: '30px' }}
                            />
                        </div>

                        <div className="w-1/6 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="billNumber">
                                Reference No
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.ChequeNumber}
                                type="text"
                                name="ChequeNumber"
                                style={{ height: '30px' }}

                            />
                        </div>

                        <div className="w-1/8 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="billNumber">
                                Reference Date
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formatDateForInput(formData.ChequeDate)}
                                type="text"
                                name="ChequeDate"
                                style={{ height: '30px' }}

                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="billNumber">
                                {selectedPaymentmethodType && selectedPaymentmethodType.value === 3 ? 'Cheque Details' : 'Reference Details'}
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-black-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.chequeDetails}
                                type="text"
                                placeholder=""
                                name="chequeDetails"
                                style={{ height: '30px' }}
                                disabled={showBankField || (selectedPaymentmethodType && selectedPaymentmethodType.value === '1')}
                            />
                        </div>

                        <div className="w-1/4 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs mb-2" htmlFor="billNumber">
                                Remarks
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                type="text"
                                placeholder="Remarks"
                                name="Remarks"
                                value={formData.Remarks}
                                readOnly
                                style={{ height: '30px', width: '100%' }}
                            />
                        </div>

                    </div>
                </div>
            </div>
            {invoicedeatils.length > 0 && (
                <div style={{ backgroundColor: 'whitesmoke', padding: '7px', borderRadius: '10px', marginTop: '5px', boxShadow: "0 6px 10px rgba(0, 0, 0, 0.25), 0 12px 25px rgba(0, 0, 0, 0.2)" }}>
                    {/* <div className="rounded-lg shadow-lg p-2">                    
                </div> */}
                    <div className="w-full mb-2 flex">
                        <div className="w-full mb-2 flex">
                            {invoicedeatils.length > 0 && (
                                <TableContainer component={Paper}>
                                    <Table>
                                        <TableHead>
                                            <TableRow sx={{ backgroundColor: '#435560', }}>
                                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bold', fontSize: '11px', padding: '3px', textTransform: 'uppercase', color: 'white' }}>
                                                    Bill Details
                                                </TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bold', fontSize: '11px', padding: '3px', textTransform: 'uppercase', textAlign: 'right', color: 'white' }}>
                                                    Bill Amt
                                                </TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bold', fontSize: '11px', padding: '3px', textTransform: 'uppercase', textAlign: 'right', color: 'white' }}>
                                                    Paid Amt
                                                </TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bold', fontSize: '11px', padding: '3px', textTransform: 'uppercase', textAlign: 'right', color: 'white' }}>
                                                    Bal Amt
                                                </TableCell>
                                                <TableCell sx={{ borderBottom: '1px solid #F5F5F5', fontWeight: 'bold', fontSize: '11px', padding: '3px', textTransform: 'uppercase', textAlign: 'right', color: 'white' }} />
                                            </TableRow>
                                        </TableHead>

                                        <TableBody sx={{ backgroundColor: 'whitesmoke' }}>
                                            {invoicedeatils.map((invdetail) => (
                                                <TableRow key={invdetail.Id}>
                                                    <TableCell style={{ borderBottom: '1px solid #b3cff3ff', padding: '4px' }}>
                                                        {invdetail.SaleDescription}
                                                    </TableCell>

                                                    {/* Bill Amount */}
                                                    <TableCell style={{ borderBottom: '1px solid #b3cff3ff', textAlign: 'right', padding: '4px' }}>
                                                        {invdetail.Amount != null ? Number(invdetail.Amount).toFixed(3) : "-"}
                                                    </TableCell>

                                                    {/* Paid Amount */}
                                                    <TableCell style={{ borderBottom: '1px solid #b3cff3ff', textAlign: 'right', color: 'black', padding: '4px' }}>
                                                        {invdetail.PaidNow != null
                                                            ? Number(invdetail.PaidNow).toFixed(3)
                                                            : invdetail.PaidAmount != null
                                                                ? Number(invdetail.PaidAmount).toFixed(3)
                                                                : "-"}
                                                    </TableCell>

                                                    {/* Balance Amount */}
                                                    <TableCell style={{ borderBottom: '1px solid #b3cff3ff', textAlign: 'right', color: 'red', padding: '4px' }}>
                                                        {invdetail.NewBalance != null
                                                            ? Number(invdetail.NewBalance).toFixed(3)
                                                            : invdetail.BalanceAmount != null
                                                                ? Number(invdetail.BalanceAmount).toFixed(3)
                                                                : "-"}
                                                    </TableCell>

                                                    <TableCell style={{ borderBottom: '1px solid #b3cff3ff' }} />
                                                </TableRow>
                                            ))}

                                            {/* === Totals Calculation === */}
                                            {(() => {
                                                const totalBill = invoicedeatils.reduce((sum, inv) => sum + Number(inv.Amount || 0), 0);
                                                const totalPaid = invoicedeatils.reduce(
                                                    (sum, inv) => sum + Number(inv.PaidNow ?? (inv.PaidAmount || 0)),
                                                    0
                                                );
                                                const totalBalance = invoicedeatils.reduce(
                                                    (sum, inv) => sum + Number(inv.NewBalance ?? (inv.BalanceAmount || 0)),
                                                    0
                                                );

                                                return (
                                                    <>
                                                        {/* === Footer Row (Total) === */}
                                                        <TableRow sx={{ backgroundColor: '#f3f7f6ff' }}>
                                                            <TableCell colSpan={1} sx={{ fontWeight: 'bold', padding: '4px', color: 'black' }}>
                                                                Total
                                                            </TableCell>

                                                            {/* Total Bill Amount */}
                                                            <TableCell sx={{ textAlign: 'right', fontWeight: 'bold', padding: '4px' }}>
                                                                {invoicedeatils.reduce((sum, inv) => sum + Number(inv.Amount || 0), 0).toFixed(3)}
                                                            </TableCell>

                                                            {/* Total Paid */}
                                                            <TableCell sx={{ textAlign: 'right', fontWeight: 'bold', color: 'darkmagenta', padding: '4px' }}>
                                                                {invoicedeatils.reduce(
                                                                    (sum, inv) => sum + Number(inv.PaidNow ?? (inv.PaidAmount || 0)),
                                                                    0
                                                                ).toFixed(3)}
                                                            </TableCell>

                                                            {/* Total Balance */}
                                                            <TableCell sx={{ textAlign: 'right', fontWeight: 'bold', color: 'brown', padding: '4px' }}>
                                                                {invoicedeatils.reduce(
                                                                    (sum, inv) => sum + Number(inv.NewBalance ?? (inv.BalanceAmount || 0)),
                                                                    0
                                                                ).toFixed(3)}
                                                            </TableCell>
                                                            <TableCell />
                                                        </TableRow>

                                                        {/* === Advance Row (Only if Amount > Total Bill Amount) === */}
                                                        {Number(formData.Amount) >
                                                            invoicedeatils.reduce((sum, inv) => sum + Number(inv.Amount || 0), 0) && (
                                                                <TableRow sx={{ backgroundColor: '#f9fcf3ff' }}>
                                                                    <TableCell colSpan={2} sx={{ fontWeight: 'bold', padding: '4px', color: 'black' }}>
                                                                        Advance
                                                                    </TableCell>
                                                                    <TableCell
                                                                        colSpan={2}
                                                                        sx={{ textAlign: 'right', fontWeight: 'bold', color: 'darkblue', padding: '4px' }}
                                                                    >
                                                                        {(
                                                                            Number(formData.Amount) -
                                                                            invoicedeatils.reduce((sum, inv) => sum + Number(inv.Amount || 0), 0)
                                                                        ).toFixed(3)}
                                                                    </TableCell>
                                                                    <TableCell />
                                                                </TableRow>
                                                            )}
                                                    </>
                                                );
                                            })()}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            )}

                        </div>
                    </div>
                </div>
            )}


        </div >
    );
}

export default PaymentAndReceiptDetails;
